module.exports = __webpack_public_path__ + "static/media/alt_route.4ff3f6da.svg";